// requires videotranscripts.js
const videoGalleryPage = function () {	
	const infoVideos = new infoVideos4i();
	const videoTranscripts = new videoTranscripts4i();
	const common = new videoCommon();
	const vidContainer = document.getElementById("videoContainer");
	const transcriptDiv = document.getElementById("transcriptContainer");
	const mugImprintBtn = document.getElementById("mugImprintVideo");
	
	const init = () => {
		videoTranscripts.Init();
		common.ShowFromDialog();
		
		const whyBuyBtn = document.getElementById("whyBuyVideo");
		whyBuyBtn.addEventListener('click', showWhyBuy);
		mugImprintBtn.addEventListener('click', showMugImprint);
		
		if (window.location.hash != "#mugimprints"){
			//whyBuyBtn.click(); // show why buy video by default if nothing else was specified
			infoVideos.InitWhyBuy();
		}
		
		setTimeout(() =>{ common.AddLinks(); }, 300);	
	};
	
	const showWhyBuy = (e) =>{
    		e.preventDefault();
    		infoVideos.InitWhyBuy(true);
        	showPlayer("Why Buy From Us");
	};
	
	const showMugImprint = (e) =>{
		e.preventDefault();
    		infoVideos.InitMugImprint(true);
        	showPlayer("Mug Imprints");
	};
	
	const showPlayer = (vidTitle) =>{
		videoTranscripts.Collapse();
		const vidTitleHeading = document.getElementById("playVidTitle");
		vidTitleHeading.innerHTML = vidTitle;
		updateTranscript();
	};
	
	const updateTranscript = () =>{
		// wait for the transcript to be fetched and then update the height/whether to show button
		// will be triggered when the transcriptContainer element's children change
		const config = { childList: true, subtree: true };
		const callback = (mutationsList, observer) => {
			for (let i = 0; i < mutationsList.length; i++) {
 				if (mutationsList[i].type === 'childList') {
					vidContainer.scrollIntoView({behavior: "smooth"});
 					document.querySelector("#bitmovinplayer-video-player").focus();
    					scriptObserver.disconnect();
    					videoTranscripts.GetHeight();
				}
			}
		};
		const scriptObserver = new MutationObserver(callback);
		scriptObserver.observe(transcriptDiv, config);
	};

	return{
		Init: init
	};
};

(async () =>{
	const videoPage = new videoGalleryPage();
	videoPage.Init();
})();